import { Consent } from '@axo/form/feature/axo-form-v2/lib/components';
import { EmailFieldUI } from '@axo/form/feature/form-input/EmailField/EmailFieldUI';
import { PhoneFieldUI } from '@axo/form/feature/form-input/PhoneField/PhoneFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useAxoFormContext } from '../../../../../../context/AxoForm/AxoForm';
import { useMarketingConsent } from '../../../../../../hooks/useMarketingConsent';
import { useEmailValidation } from '../../../../../../utils/useEmailValidation';
import { CustomerFormGroupData } from '../../../FormData.se.types';
import {
  getEmailRegisterOptions,
  phoneFieldOptions,
} from '../../shared-config';

type CustomerFormGroupProps = {
  isEmailValid: boolean;
  setIsEmailValid: (value: boolean) => void;
};

export const CustomerFormGroup = ({
  isEmailValid,
  setIsEmailValid,
}: CustomerFormGroupProps) => {
  const { t } = useTranslation();

  const { baseUrl, axoFormData } = useAxoFormContext<CustomerFormGroupData>();

  const { setValue, watch } = useFormContext();

  const { formError, isValid, EmailPrompt, enableEmailValidation } =
    useEmailValidation({
      baseUrl,
      email: watch('Customer/Email'),
      setEmail: (email) => setValue('Customer/Email', email),
    });

  const emailRegisterOptions = getEmailRegisterOptions(enableEmailValidation);

  const { showMarketingConsent = true } = useMarketingConsent({
    marketingConsent: axoFormData['Ignore/MarketingConsent'],
    shouldShowMarketingConsent: axoFormData['Ignore/ShowMarketingConsent'],
  });

  useEffect(() => {
    if (isEmailValid === !!isValid) return;

    setIsEmailValid(!!isValid);
  }, [isValid, setIsEmailValid, isEmailValid]);

  return (
    <>
      <PhoneFieldUI<CustomerFormGroupData>
        name="Customer/MobilePhoneNumber"
        label={t('MobilePhoneNumber.label')}
        data-testid="phone-number-input"
        format="*** *** ** **"
        {...phoneFieldOptions}
      />

      <EmailFieldUI<CustomerFormGroupData>
        name="Customer/Email"
        label={t('Email.label')}
        data-testid="email-input"
        registerOptions={emailRegisterOptions}
        error={formError}
        confirmationPrompt={<EmailPrompt />}
      />

      <Consent showMarketingConsent={showMarketingConsent}>
        <Consent.TermsAndConditions />
        <Consent.Marketing />
      </Consent>
    </>
  );
};
